import { ColumnDef } from "@tanstack/react-table";
import i18next from "i18next";

export const nebulizerTableColumns: ColumnDef<any, string>[] = [
  {
    accessorKey: "source",
    header: () => i18next.t("patientPage_columns_source"),
    cell: (info) => info.renderValue(),
    size: 220,
  },
  {
    accessorKey: "serialNumber",
    header: () => i18next.t("patientPage_columns_serial_no"),
    cell: (info) => info.renderValue(),
    size: 220,
  },
  {
    accessorKey: "duration",
    header: () => i18next.t("patientPage_columns_duration_sec"),
    cell: (info) => info.renderValue(),
    size: 220,
  },
  {
    accessorKey: "date",
    header: () => i18next.t("patientPage_columns_date"),
    cell: (info) => info.renderValue(),
    size: 220,
  },
  {
    accessorKey: "status",
    header: () => i18next.t("patientPage_columns_status"),
    cell: (info) => info.renderValue(),
    size: 220,
  },
];
